module.exports = __webpack_public_path__ + "static/media/star-prata.5ba42279.webp";